import { useEffect, useState } from 'react'

import { formatPhone, formatDate } from 'admin/adminutil'

import { getUserTotalAmount, handleSort, performSort, sortSpan } from '../auctionsadminutil'

import { formatName } from '../auctionsadminutil'

import css from './sass/liveauction.module.scss'
import adminCss from '../sass/adminpage.module.scss'
import themeCss from '../../components/sass/theme.module.scss'
import AuctionRegistrationRow from './AuctionRegistrationRow'
import SortNotice from '../SortNotice'
import StatSummary from '../StatSummary'
import { isAuctionOwner } from '../permissionsutil'
import { calculateUserBalance } from 'sites/auctions/util/endedAuctionUtils'

export default function LiveAttendeeView(props) {
  const [showCheckInFilter, setShowCheckInFilter] = useState(true)
  const [showNotCheckedInFilter, setShowNotCheckedInFilter] = useState(true)
  const [nameFilter, setNameFilter] = useState('')

  //array of truth for all registrations in auction
  const [allRegistrations, setAllRegistrations] = useState([])

  //filtered list based off selection
  const [displayedRegistrations, setDisplayedRegistrations] = useState([])

    //for table sorting
    const [sortOptions, setSortOptions] = useState({ key: '', dir: 'asc' })

    let tableFormatter = [
      ['FullName', 'Attendee Name'],
      ['BidCount', 'Bid Count'],
      ['TotalAmount', 'Total Amount'],
      ['CheckStr', 'Checked In?'],
      ['EmailStr', 'Email'],
      ['CrmId', 'CRM ID'],
      ['PhoneStr', 'Phone'],
      ['RegDate', 'Register Date'],
    ]

  const auctionDetail = props.auction

  //remove email, crm id and phone for collaborators
  if (!isAuctionOwner(auctionDetail)) {
    tableFormatter = [
      ['FullName', 'Attendee Name'],
      ['BidCount', 'Bid Count'],
      ['TotalAmount', 'Total Amount'],
      ['CheckStr', 'Checked In?'],
      ['RegDate', 'Register Date'],
    ]
  }

  if (!auctionDetail.NeedsCheckin) tableFormatter.splice(3, 1)

  useEffect(() => {
    if (auctionDetail) {

      const bidObj = {}
      auctionDetail.Bids.forEach((bid) => {
        const user = bid.UserId
        bidObj[user] = (bidObj[user] || 0) + 1
      })

      // const userWinningAmountObj = {}

      // auctionDetail.Items.forEach((item) => {
      //   const user = item.CurrentHighBidder
      //   userWinningAmountObj[user] = (userWinningAmountObj[user] || 0) + item.CurrentBid
      // })

      // console.log('total', totals)

      const formattedRegistrations = auctionDetail.Registrations.map((reg) => {
        return {
          ...reg,
          FullName: formatName(reg),
          BidCount: bidObj[reg.User.UserId] || '0',
          TotalAmount: getUserTotalAmount(auctionDetail, reg.User.UserId) || '0',
          CheckStr: (reg.IsCheckedIn ? 'Yes' : "No"),
          EmailStr: reg.User.ContactEmail,
          CrmId :reg.User.CrmId,
          PhoneStr :formatPhone(reg.User.ContactPhone),
          RegDate : formatDate(reg.DateCreated, true),
        }
      }) 

      setAllRegistrations(formattedRegistrations)
    }
  }, [auctionDetail])

  //filter for displayed attendees
  useEffect(() => {

    let filtered = [...allRegistrations]
    
    if (filtered.length === 0) return

    if (nameFilter) {
      const normalizedNameFilter = nameFilter.toLowerCase()

      filtered = allRegistrations?.filter((registration) => {
        return (registration.User.FirstName?.toLowerCase().includes(normalizedNameFilter)) ||
          (registration.User.LastName?.toLowerCase().includes(normalizedNameFilter))
      })
    }
    
    const output = filtered.filter((registration) => {
      return (showCheckInFilter && registration.IsCheckedIn) || (showNotCheckedInFilter && !registration.IsCheckedIn)
    })

    let sorted = []

    if (sortOptions.key === '') sorted = performSort(output, {key: 'FullName', direction: 'asc'})
    else sorted = performSort(output, sortOptions)

    setDisplayedRegistrations(sorted)

  }, [showNotCheckedInFilter, showCheckInFilter, allRegistrations, nameFilter, sortOptions])

  const resetFilters = () => {
    setShowCheckInFilter(true)
    setShowNotCheckedInFilter(true)
    setNameFilter('')
  }

  if (!auctionDetail?.NeedsCheckin && tableFormatter.length === 6) {
    tableFormatter.splice(1, 1)
  }

  // make sure to update this if the columns in LiveAuctionRegistrationRow change
  const copyAttendeesToClipboard = () => {
    let textToCopy = ''

    if (isAuctionOwner(auctionDetail)) {
      if (auctionDetail?.NeedsCheckin) {
        textToCopy = [tableFormatter.map(headerName => headerName[1]).join('\t')];
        displayedRegistrations.forEach(row => {
          textToCopy.push([
            formatName(row), row.BidCount, "$"+row.TotalAmount,
            row.IsCheckedIn ? 'Yes' : "No",
            row.User.ContactEmail, row.User.CrmId.length > 0 ? '="'+row.User.CrmId+'"' : '',
            formatPhone(row.User.ContactPhone), formatDate(row.DateCreated),
          ].join('\t'))
        })
      } else {
        textToCopy = [tableFormatter.map(headerName => headerName[1]).join('\t')];
        displayedRegistrations.forEach(row => {
          textToCopy.push([
            formatName(row), row.BidCount, "$"+row.TotalAmount,
            row.User.ContactEmail, row.User.CrmId.length > 0 ? '="'+row.User.CrmId+'"' : '',
            formatPhone(row.User.ContactPhone), formatDate(row.DateCreated),
          ].join('\t'))
        })
      }

      //remove email, crm id and phone for collaborators
    } else {
      if (auctionDetail?.NeedsCheckin) {
        textToCopy = [tableFormatter.map(headerName => headerName[1]).join('\t')];
        displayedRegistrations.forEach(row => {
          textToCopy.push([
            formatName(row), row.BidCount, "$"+row.TotalAmount,
            row.IsCheckedIn ? 'Yes' : "No", formatDate(row.DateCreated),
          ].join('\t'))
        })
      } else {
        textToCopy = [tableFormatter.map(headerName => headerName[1]).join('\t')];
        displayedRegistrations.forEach(row => {
          textToCopy.push([
            formatName(row), row.BidCount, "$"+row.TotalAmount, formatDate(row.DateCreated),
          ].join('\t'))
        })
      }
    }

    navigator.clipboard.writeText(textToCopy.join('\n'))
  }

  if (!auctionDetail) return (<></>)

  return (
    <div className={css['live-auction-container']}>
      
      <div className={adminCss['admin-auction-items-title']}> 
        <h2 className={adminCss['admin-auction-page-tab-header']}>
          Registered Attendees
        </h2>

        <StatSummary auction={props.auction} />
      </div>
      
      {auctionDetail.NeedsCheckin && <button className={`${themeCss['button']} ${themeCss['FilledBlue']}`}>
        Go to Check-in App
      </button>}
      
      <div className={css['live-auction-attendee-filters']}>
        <div className={css['live-auction-filter']}>
          <label>
            Attendee Name
          </label>
          <input type='text' value={nameFilter} onChange={(e) => setNameFilter(e.target.value)}/>
        </div>

        {auctionDetail.NeedsCheckin && <div className={css['live-auction-filter']}>
          <div className={css['live-auction-filter-checkbox']}>
            <input type='checkbox' checked={showCheckInFilter} onChange={(e) => setShowCheckInFilter(!showCheckInFilter)} />
            <label> Show Checked in Users</label>
          </div>
          <div className={css['live-auction-filter-checkbox']}>
            <input type='checkbox' checked={showNotCheckedInFilter} onChange={(e) => setShowNotCheckedInFilter(!showNotCheckedInFilter)} />
            <label> Show Users Not Checked In</label>
          </div>
        </div>}

        <button className={`${themeCss['button']} ${themeCss['FilledYellow']}`} onClick={resetFilters}>
          Reset Filters
        </button>
      </div>

      <div>
        <p>You can click on the Attendee's name to view the user's entire Bid History.</p>
        <SortNotice />
        <table className={themeCss['data-table']}>
          <thead>
            <tr>
            {tableFormatter.map((ele) => {
              return (
                <th onClick={() => handleSort(ele[0], sortOptions, setSortOptions)} key={ele[1]}>
                  {ele[1]} {sortSpan(ele[0], sortOptions)}</th>
                )})}
            </tr>
          </thead>
          <tbody>
            {displayedRegistrations && displayedRegistrations?.map((registration) => {
            return <AuctionRegistrationRow key={registration.RegistrationId} registration={registration} 
              auctionDetail={auctionDetail} />
            })}
          </tbody>
        </table>
      </div>
      
      <button className={`${themeCss['button']} ${themeCss['FilledWhite']} ${themeCss['copyclipboard-button']}`} onClick={copyAttendeesToClipboard}>
        Copy Data to Clipboard
      </button>

    </div>
  )
}
